import { Message, IMessage, MessageTextConverter } from "./Message";


export interface IImage {
    Blob:string;
    MimeType:string;
    Preview:string;
    DisplayName: string;
}

export interface IImageMessage extends IMessage {
    Caption: string;
    Image : IImage;
}

export const ImageMessage = (props: IImageMessage) => {



    return <>
    
        <Message {...props}>
        <div className="row">
            <img src={ props.Image.Preview } className="img-fluid" alt={props.Image.DisplayName}/>
        </div>
            { props.Caption && props.Caption.length > 0 && <div className="row"><p>{MessageTextConverter.parse(props.Caption)}</p></div> }
        </Message>

    </>

}